import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Popper,
  ClickAwayListener,
  Grow,
  Paper,
  Box,
  Typography,
  Avatar,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Chip,
} from "@mui/material";

import { Search, Close, CheckCircleOutline } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssignUserMenuData,
  REQUEST_STATUS,
  resetAssignUsers,
} from "./WorkflowSiderbarSlice";

const AVATAR_COLORS = [
  "#4CAF93",
  "#8E7CC3",
  "#55A7C7",
  "#D08A4C",
  "#4CADA6",
  "#C77D8E",
  "#7C9CC7",
  "#B08A4C",
];

export default function AssignEpisodesDialog({
  open,
  onClose,
  anchorEl,
  selectedEpisodes = [],
  onAssign,
  selectedRows,
}) {
  const [selectedCoder, setSelectedCoder] = useState(null);
  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);

  const {
    data: users,
    status,
    hasMore,
  } = useSelector((state) => state.workflowsidebar.files);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    isFetchingRef.current = status === REQUEST_STATUS.LOADING;
  }, [status]);
  // console.log(users, "iufgueuyfgu");
const handleSearch = (e) => {
  setSearch(e.target.value);
  setPage(1);
};
  useEffect(() => {
    if (open) {
      dispatch(getAssignUserMenuData({
        pageNumber: page,
        search,
      }));
    }
  }, [dispatch, page,search, open]);
  useEffect(() => {
    if (!open) {
      setPage(1);
      setSearch("");
      setSelectedCoder(null);

      dispatch(resetAssignUsers());
    }
  }, [open, dispatch]);
  // useEffect(() => {
  //   if (users.length && selectedCoder === null) {
  //     setSelectedCoder(users[0].user_id);
  //   }
  // }, [users, selectedCoder]);

  const handleScroll = (e) => {
    if (isFetchingRef.current || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop - clientHeight < 20) {
      isFetchingRef.current = true; // NEW — set immediately, don't wait for status to propagate
      setPage((prev) => prev + 1);
    }
  };

  const filteredCoders = useMemo(() => {
    const value = search.toLowerCase();

    return users.filter(
      (item) =>
        item.username.toLowerCase().includes(value) ||
        item.email.toLowerCase().includes(value),
    );
  }, [users, search]);

  const handleAssign = () => {
    const coder = users.find((user) => user.user_id === selectedCoder);

    onAssign?.({
      coder,
      episodes: selectedEpisodes,
    });

    onClose();
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      transition
      style={{ zIndex: 1300 }}
      modifiers={[
        { name: "offset", options: { offset: [0, 8] } },
        { name: "preventOverflow", options: { boundary: "viewport" } },
      ]}
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: "top left" }}>
          <Paper
            elevation={6}
            sx={{
              width: 280,
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            <ClickAwayListener onClickAway={onClose}>
              <Box>
                {/* Header */}
                <Box
                  sx={{
                    px: 3,
                    pt: 3,
                    pb: 2,
                    borderBottom: "1px solid #ECECEC",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "22px",
                        fontWeight: 700,
                        lineHeight: "28px",
                        color: "#172B4D",
                      }}
                    >
                      Assign Episodes
                    </Typography>

                    <IconButton size="small" onClick={onClose}>
                      <Close />
                    </IconButton>
                  </Box>

                  <Chip
                    label={`${selectedEpisodes.length} episodes selected`}
                    sx={{
                      mt: 1.5,
                      height: 24,
                      bgcolor: "#EAF7FC",
                      color: "#3A8FB7",
                      border: "1px solid #BFE5F4",
                      borderRadius: "8px",
                      "& .MuiChip-label": {
                        px: 1.2,
                        fontSize: "12px",
                        fontWeight: 500,
                        lineHeight: "16px",
                      },
                    }}
                  />
                </Box>

                {/* Search */}
                <Box sx={{ px: 2, pt: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="Search coder by name or email"
                    value={search}
                     onChange={handleSearch}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ fontSize: 18, color: "#98A2B3" }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: 40,
                        borderRadius: 2,
                        bgcolor: "#FAFBFC",
                      },
                      "& input": {
                        fontSize: "14px",
                      },
                      "& input::placeholder": {
                        fontSize: "14px",
                        opacity: 0.5,
                      },
                    }}
                  />
                </Box>

                {/* List */}
                <Box
                  onScroll={handleScroll}
                  sx={{
                    mt: 2,
                    px: 2,
                    maxHeight: 220,
                    overflowY: "auto",
                  }}
                >
                  {filteredCoders.map((coder) => {
                    const selected = coder.user_id === selectedCoder;

                    return (
                      <Box
                        key={coder.user_id}
                        onClick={() => setSelectedCoder(coder.user_id)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          p: 1,
                          borderRadius: 1.5,
                          cursor: "pointer",
                          // mb: 1,

                          bgcolor: selected ? "#EEF8FC" : "#fff",

                          transition: ".2s",

                          "&:hover": {
                            bgcolor: "#F7FAFC",
                          },
                        }}
                      >
                        <Avatar
                          sx={{
                            // bgcolor: AVATAR_COLORS[index % AVATAR_COLORS.length],
                            width: 30,
                            height: 30,
                            mr: 2,
                          }}
                        >
                          {coder.username.charAt(0).toUpperCase()}
                        </Avatar>

                        <Box flex={1}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                          >
                            {coder.username}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "10px",
                              color: "#98A2B3",
                            }}
                          >
                            {coder.email}
                          </Typography>
                        </Box>

                        <CheckCircleOutline
                          sx={{
                            color: selected ? "#45A7D8" : "#D5DDE6",
                            fontSize: 20,
                          }}
                        />
                      </Box>
                    );
                  })}

                  {/* {filteredCoders.length === 0 && (
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#98A2B3",
                        fontSize: "14px",
                        py: 2,
                      }}
                    >
                      No coders found
                    </Typography>
                  )} */}

                  {status === REQUEST_STATUS.LOADING && (
                    <Typography
                      sx={{
                        textAlign: "center",
                        color: "#98A2B3",
                        fontSize: "12px",
                        py: 1,
                      }}
                    >
                      Loading more…
                    </Typography>
                  )}
                </Box>
                {!hasMore && status !== REQUEST_STATUS.LOADING && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#98A2B3",
                      fontSize: 12,
                      py: 1,
                    }}
                  >
                    {filteredCoders.length > 0
                      ? "No more users"
                      : "No coders found"}
                  </Typography>
                )}

                {/* Footer */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 2,
                    p: 2,
                    borderTop: "1px solid #ECECEC",
                  }}
                >
                  <Button
                    onClick={onClose}
                    sx={{
                      textTransform: "none",
                      color: "#667085",
                      fontSize: "12px",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    onClick={handleAssign}
                    sx={{
                      bgcolor: "#083B6E",
                      borderRadius: 2,
                      px: 4,
                      textTransform: "none",
                      fontSize: "12px",
                      fontWeight: 500,
                      boxShadow: "none",

                      "&:hover": {
                        bgcolor: "#083B6E",
                      },
                    }}
                  >
                    Assign
                  </Button>
                </Box>
              </Box>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
